import React from 'react';
import moment from 'moment';
import { Link } from 'gatsby';

export class CalendarItem extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  get date () {
    if (!(this.props.eventSchedule && this.props.eventSchedule.length > 0)) return '';
    let first = this.props.eventSchedule[0].schedule?.length > 0 ? this.props.eventSchedule[0].schedule[0] : false;
    if (!first) return '';

    if (!first.endDate) return moment(first.startDate).format('DD.MM.YYYY');

    return [
      moment(first.startDate).format('DD.MM.YY'),
      moment(first.endDate).format('DD.MM.YY')
    ].join(' - ')
  }

  get passed () {
    const now = moment();

    return this.props.eventSchedule.every(schedule => schedule.schedule && schedule.schedule.every(time => {
      const endTime = moment(time.endDate || time.startDate);
      return endTime.isBefore(now);
    }));
  }

  get locations () {
    const items = this.props.eventSchedule
            .filter(schedule => schedule.location)
            .map(schedule => schedule.location)
            .map(location => location.name);

    return [...new Set(items)]
  }

  get regions () {
    const items = this.props.eventSchedule
            .filter(schedule => schedule.location)
            .map(schedule => schedule.location)
            .filter(location => location.region)
            .map(location => location.region.name);

    return [...new Set(items)]
  }

  get region () {
    if (!this.props.schedule.location || !this.props.schedule.location.country) return '';
    if (this.props.schedule.location.country.toLowerCase() !== 'belgium') return this.props.schedule.location.country;
    return this.props.schedule.location.region;
  }

  get classList () {
    var _ = ['calendar-item'];
    if (this.passed) _.push('calendar-item--passed');
    return _.join(' ');
  }

  render () {
    return (
      <Link className={this.classList} to={this.props.slug}>
        <div className="calendar-item__date">{ this.date } </div>
        <div className="calendar-item__title">{ this.props.longTitle }</div>
        <div className="calendar-item__category">{ this.props.categories.map(category => <div>{category.title}</div>)}</div>
        <div className="calendar-item__venue">{ this.locations.map(location => <div>{location}</div>) }</div>
        <div className="calendar-item__region">{ this.regions.map(region => <div>{region}</div>) } </div>
      </Link>
    );
  }
}
